module.exports = __webpack_public_path__ + "img/1cube truck to 1bakkie.1485ccf8.svg";